// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2N3cN","label":"CategoryService_label__FBwAU","location":"CategoryService_location__1_ouv"};